<div class="row margin-bottom mb16">
  <div class="col">
    <div class="policy-info-content">
      <div class="row">
        <div class="col">
          <ng-container *ngIf="isAcmic; else maButton">
            <div class="margin-vertical mt15">
              <mapfre-button additionalClasses="ghost primary large full no-margin" [routerLink]="['/signup','edit-policy']"
                [translateValue]=" 'REVIEW_DETAILS_LINK' | translate ">
                {{ 'REVIEW_DETAILS_LINK' | translate }}
              </mapfre-button>
            </div>
          </ng-container>
          <ng-template #maButton>
            <div class="margin-vertical mt15 text-center">
              <mapfre-button additionalClasses="basic primary large-btn" [routerLink]="['/signup','edit-policy']"
                [translateValue]=" 'REVIEW_DETAILS_LINK' | translate ">
                {{ 'REVIEW_DETAILS_LINK' | translate }}
              </mapfre-button>
            </div>            
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<hr>
<div class="row margin-bottom text-center mb16">   
    <ng-container *ngIf="isAcmic; else MAstate">
      <div class="sub-title-copy lowercase"> 
      If you don't recognize that email and the data entered is correct, please don't hesitate to contact our Customer Service Department by calling
      <a href="tel:18442954500">1-844-295-4500</a> {{ 'POLICY_LINKED_TO_ANOTHER_FOR_OR' | translate }}
      <a href="mailto:eccservicecenter@Insure.WA.AAA.com">{{ 'POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL' | translate }}</a>
      </div>
  </ng-container>
    <ng-template #MAstate>
      <div class="col grey-color"> 
      <div class="padding-horizontal-15">
        If you don't recognize that email and the data entered is correct, please don't hesitate to contact our Customer
        Service Department by calling
        <a href="tel:18556273737" class="dm-sans-medium link mapfre red-link underline">1-855-627-3737</a> {{
        'POLICY_LINKED_TO_ANOTHER_FOR_OR' | translate }}
        <a href="mailto:Generalcomments@mapfreusa.com" class="dm-sans-medium link mapfre red-link underline">{{
          'POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL' | translate }}</a>
      </div>
    </div>
    </ng-template>    
</div>